module.exports = __webpack_public_path__ + "img/button.10e6aa4f.png";